/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// React-Select component and styling
import Select from "react-select";
import "../../../index.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createUserDetails,
  deleteUserDetails,
  getAllClients,
  getAllRoles,
  getRoleByClient,
  getSubModulesByRoleId,
  getUserRolesByDepartment,
  getUsersDetails,
  updateUserDetails,
} from "../../../store";

// Cookies
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const UserDetails = ({
  userDetailsReducer,
  getUsersDetails,
  createUserDetails,
  updateUserDetails,
  deleteUserDetails,
  getAllRoles,
  getAllClientsReducer,
  getAllRolesReducer,
  getAllClients,
  getUserRolesByDepartment,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getRoleByClientReducer,
  getRoleByClient,
}) => {
  let userDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = userDetails?.jwt;

  let roleId = userDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let userDetailsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "f237efa9-3f56-4040-b2c9-32d34cf687ea",
  );

  let createAccess = userDetailsModule
    ? userDetailsModule.actionId.includes(
        "17afc769-13c4-4739-9438-0538b5aa2c6f",
      )
    : null;

  let viewAccess = userDetailsModule
    ? userDetailsModule.actionId.includes(
        "9b8a8348-89c0-4d9c-8811-832c5c8d6024",
      )
    : null;

  let updateAccess = userDetailsModule
    ? userDetailsModule.actionId.includes(
        "4cb81139-316a-4b4e-a073-105f260fab91",
      )
    : null;

  let deleteAccess = userDetailsModule
    ? userDetailsModule.actionId.includes(
        "42109cba-2463-46ee-84ea-7181c090088f",
      )
    : null;

  useEffect(() => {
    getUsersDetails(jwtToken);
  }, []);
  useEffect(() => {
    getAllClients(jwtToken);
  }, []);

  const [state, setState] = useState({
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "User Name", accessor: "userName", align: "left" },
      { Header: "Email", accessor: "email", align: "left" },

      { Header: "Role", accessor: "roleName", align: "left" },
      {
        Header: "Action",
        accessor: "actions",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempUserDetails = [];
    let data = userDetailsReducer.usersDetails.data
      ? userDetailsReducer.usersDetails.data
      : [];
    setLoading(userDetailsReducer.loading);

    data.map((user) => {
      const userObject = {
        name: user.name,
        userName: user.userName,
        email: user.email,

        roleName: user.roleName,
        actions: (
          <div>
            {updateAccess ? (
              <EditButton
                tooltip="Edit Details"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenEditUserDetailsModal(user);
                  getAllRoles(jwtToken);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            ) : (
              <EditButton
                tooltip="Edit Details"
                disabled
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenEditUserDetailsModal(user)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}

            {deleteAccess ? (
              <DeleteButton
                style={{ marginLeft: "5px" }}
                tooltip="Delete Details"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                onClick={() => handleOpenDeleteUserDetailsModal(user)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            ) : (
              <DeleteButton
                tooltip="Delete Details"
                disabled
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                onClick={() => handleOpenDeleteUserDetailsModal(user)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
          </div>
        ),
      };
      tempUserDetails.push(userObject);
    });

    viewAccess && setState({ ...state, rows: tempUserDetails });
  }, [userDetailsReducer]);

  const [rolesOptions, setRolesOptions] = useState([]);
  useEffect(() => {
    let roles = getAllRolesReducer?.rolesData?.data
      ? getAllRolesReducer?.rolesData?.data
      : [];

    let rolesOptionsTemp = [];
    roles.map((role) => {
      rolesOptionsTemp.push({ label: role.roleName, value: role.roleId });
    });

    setRolesOptions(rolesOptionsTemp);
  }, [getAllRolesReducer]);

  const [roleSelected, setRoleSelected] = useState("");
  const handleRoleSelected = (selectedOption) => {
    setRoleSelected(selectedOption);
  };

  const [roleByClientSelected, setRoleByClientSelected] = useState({});
  const handleRoleByClientSelected = (selectedOption) => {
    setRoleByClientSelected(selectedOption);
  };

  const [roleByClientOptions, setRoleByClientOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getRoleByClientReducer.roles.data
      ? getRoleByClientReducer.roles.data
      : [];

    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.roleName,
        value: document.roleId,
      });
    });
    setRoleByClientOptions(tempDocumentTypeOptions);
  }, [getRoleByClientReducer]);

  const [createUserDetailsModal, setCreateUserDetailsModal] = useState(false);
  const handleCreateUserDetailsModal = () => {
    setCreateUserDetailsModal(true);
    setRoleSelected("");

    setIsErrorCreateUserDetails(false);
    setIsSuccessCreateUserDetails(false);
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
    getAllRoles(jwtToken);
  };
  const handleCloseCreateUserDetailsModal = () => {
    setCreateUserDetailsModal(false);
    setRoleByClientSelected("");
    setClientSelected("");
  };

  const [isErrorCreateUserDetails, setIsErrorCreateUserDetails] =
    useState(false);
  const [isSuccessCreateUserDetails, setIsSuccessCreateUserDetails] =
    useState(false);

  useEffect(() => {
    if (isErrorCreateUserDetails) {
      setTimeout(() => {
        setIsErrorCreateUserDetails(false);
      }, 3000);
    }
  }, [isErrorCreateUserDetails]);

  useEffect(() => {
    if (isSuccessCreateUserDetails) {
      setTimeout(() => {
        setIsSuccessCreateUserDetails(false);
      }, 3000);
    }
  }, [isSuccessCreateUserDetails]);

  const initialValues = {
    name: "",
    username: "",
    email: "",
    roleId: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Enter a valid name!"),
    username: Yup.string().required("Enter a valid user name!"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Enter a valid email!"),
    // roleId: Yup.object().required("Select a role!"),
  });

  const [createErrorMsg, setCreateErrorMsg] = useState("");

  const [clientSelected, setClientSelected] = useState({});
  const handleClientSelected = (selectedOption) => {
    setClientSelected(selectedOption);
  };

  const [componentOptions, setComponentOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);

  useEffect(() => {
    getRoleByClient(clientSelected?.value, jwtToken);
  }, [clientSelected]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getAllClientsReducer.clients.data
      ? getAllClientsReducer.clients.data
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.clientName,
        value: document.clientId,
      });
    });
    setClientOptions(tempDocumentTypeOptions);
  }, [getAllClientsReducer]);

  const onSubmit = async (values, { resetForm }) => {
    // values.loginId = loginIdSelected.value;
    // values.departmentId = departmentSelected.value;

    // values.roleId = roleSelected.value;

    const payload = {
      name: values.name,
      username: values.username, // Assuming departmentId is to be set or filled later
      email: values.email,
      roleId: roleByClientSelected.value,
      clientId: clientSelected.value,
    };
    // values.departmentName = departmentSelected.label;
    // values.roleName = roleSelected.label;

    let res = await createUserDetails(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreateUserDetails(true);
      setRoleSelected("");
      setRoleByClientSelected("");
      setClientSelected("");

      getUsersDetails(jwtToken);
      setTimeout(() => {
        handleCloseCreateUserDetailsModal();
      }, 2000);
      resetForm();
    }
    if (!res.status) {
      setCreateErrorMsg(res.data.data.message);
      setIsErrorCreateUserDetails(true);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [openEditUserDetailsModal, setOpenEditUserDetailsModal] =
    useState(false);
  const [singleUserDetailsDataForUpdate, setSingleUserDetailsDataForUpdate] =
    useState({});

  const handleOpenEditUserDetailsModal = (userDetails = {}) => {
    getUserRolesByDepartment(userDetails.departmentId);

    setRoleSelected({ label: userDetails.roleName, value: userDetails.roleId });
    setSingleUserDetailsDataForUpdate(userDetails);
    setOpenEditUserDetailsModal(true);
  };

  const handleCloseEditUserDetailsModal = () => {
    setRoleSelected("");

    setOpenEditUserDetailsModal(false);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
    formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    // roleId: singleUserDetailsDataForUpdate.roleId,
    email: singleUserDetailsDataForUpdate.email,
    roleId: singleUserDetailsDataForUpdate.roleName,

    username: singleUserDetailsDataForUpdate.userName,
    name: singleUserDetailsDataForUpdate.name,
  };

  const validationSchemaForUpdate = Yup.object({
    name: Yup.string().required("Enter a valid name!"),
    username: Yup.string().required("Enter a valid user name!"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Enter a valid email!"),
    // roleId: Yup.object().required("Select a role!"),
  });

  const [updateErrorMsg, setUpdateErrorMsg] = useState("");

  const onSubmitForUpdate = async (values) => {
    // values.loginId = loginIdSelected.value;
    // values.departmentId = departmentSelected.value;
    // values.roleId = roleSelected.value;
    // values.departmentName = departmentSelected.label;

    values.roleId = roleSelected.value;
    let res = await updateUserDetails(values, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getUsersDetails(jwtToken);
    }
    if (!res.status) {
      setUpdateErrorMsg(res.data.data.message);
      setIsErrorForUpdate(true);
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [openDeleteUserDetailsModal, setOpenDeleteUserDetailsModal] =
    useState(false);
  const [singleUserDetailsDataForDelete, setUserDetailsDataForDelete] =
    useState({});

  const [isErrorDeleteUser, setIsErrorDeleteUser] = useState(false);
  const [isSuccessDeleteUser, setIsSuccessDeleteUser] = useState(false);

  useEffect(() => {
    if (isErrorDeleteUser) {
      setTimeout(() => {
        setIsErrorDeleteUser(false);
      }, 3000);
    }
  }, [isErrorDeleteUser]);

  useEffect(() => {
    if (isSuccessDeleteUser) {
      setTimeout(() => {
        setIsSuccessDeleteUser(false);
      }, 3000);
    }
  }, [isSuccessDeleteUser]);

  const handleOpenDeleteUserDetailsModal = (userDetails = {}) => {
    setUserDetailsDataForDelete(userDetails);
    setOpenDeleteUserDetailsModal(true);
  };
  const handleCloseDeleteUserDetailsModal = () => {
    setOpenDeleteUserDetailsModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const deleteUserDetailsData = async () => {
    let emailId = singleUserDetailsDataForDelete.email;
    let response = await deleteUserDetails(emailId, jwtToken);

    if (response.status) {
      getUsersDetails(jwtToken);
      setIsSuccessDeleteUser(true);

      setTimeout(() => {
        handleCloseDeleteUserDetailsModal();
      }, 2250);
    }
    if (!response.status) {
      setDeleteErrorMsg(response.data.data.message);
      setIsErrorDeleteUser(true);
    }
  };

  return (
    <div>
      <MDBox mt={-8}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {createAccess && (
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
              >
                <MDBox>
                  <CreateButton
                    tooltip=" Create User"
                    variant="contained"
                    type="button"
                    onClick={handleCreateUserDetailsModal}
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                </MDBox>
              </MDBox>
            )}
            <MDBox mt={createAccess ? -3 : 0}>
              {!loading ? (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "100px",
                    marginBottom: "100px",
                  }}
                >
                  <CircularProgress color="info" />
                </div>
              )}
            </MDBox>
            <Modal
              open={createUserDetailsModal}
              onClose={handleCloseCreateUserDetailsModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Create User
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseCreateUserDetailsModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="name"
                        fullWidth
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        error={
                          formik.touched.name && formik.errors.name && true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <TextError msg={formik.errors.name} />
                      )}
                    </MDBox>

                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        User Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="username"
                        fullWidth
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.username}
                        error={
                          formik.touched.username &&
                          formik.errors.username &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formik.touched.username && formik.errors.username && (
                        <TextError msg={formik.errors.username} />
                      )}
                    </MDBox>

                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Email
                      </MDTypography>

                      <MDInput
                        type="email"
                        name="email"
                        fullWidth
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        error={
                          formik.touched.email && formik.errors.email && true
                        }
                      />
                      {formik.touched.email && formik.errors.email && (
                        <TextError msg={formik.errors.email} />
                      )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Select Client
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={90}
                        name="clientId"
                        onBlur={() => {
                          formik.handleBlur({
                            target: {
                              name: "clientId",
                            },
                          });
                        }}
                        value={
                          clientSelected
                            ? clientOptions.find(
                                (option) =>
                                  option.value === clientSelected.value,
                              )
                            : null
                        }
                        options={clientOptions}
                        onChange={(selectedOption) => {
                          handleClientSelected(selectedOption);
                          formik.setFieldValue("clientId", selectedOption);
                        }}
                      />
                      {formik.touched.clientId && formik.errors.clientId && (
                        <TextError msg={formik.errors.clientId} />
                      )}
                    </MDBox>

                    <MDBox mb={2}>
                      <MDTypography variant="h6">Role</MDTypography>
                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Choose one..."
                        name="roleId"
                        options={rolesOptions}
                        value={
                          roleByClientSelected
                            ? rolesOptions.find(
                                (option) =>
                                  option.value === roleByClientSelected.value,
                              )
                            : null
                        }
                        onChange={(selectedOption) => {
                          handleRoleByClientSelected(selectedOption);
                          formik.setFieldValue("roleId", selectedOption);
                        }}
                      />
                      {formik.errors.roleId && (
                        <TextError msg={formik.errors.roleId} />
                      )}
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorCreateUserDetails}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorCreateUserDetails(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {/* Please check the details. Server error! */}
                          {createErrorMsg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessCreateUserDetails}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessCreateUserDetails(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          User Details Created Successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={!formik.isValid}
                      >
                        Submit
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openEditUserDetailsModal}
              onClose={handleCloseEditUserDetailsModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update User Details
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseEditUserDetailsModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="name"
                        fullWidth
                        autoComplete="off"
                        onChange={formikForUpdate.handleChange}
                        onBlur={formikForUpdate.handleBlur}
                        value={formikForUpdate.values.name}
                        error={
                          formikForUpdate.touched.name &&
                          formikForUpdate.errors.name &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForUpdate.touched.name &&
                        formikForUpdate.errors.name && (
                          <TextError msg={formikForUpdate.errors.name} />
                        )}
                    </MDBox>

                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        User Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="username"
                        fullWidth
                        autoComplete="off"
                        onChange={formikForUpdate.handleChange}
                        onBlur={formikForUpdate.handleBlur}
                        value={formikForUpdate.values.username}
                        error={
                          formikForUpdate.touched.username &&
                          formikForUpdate.errors.username &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForUpdate.touched.username &&
                        formikForUpdate.errors.username && (
                          <TextError msg={formikForUpdate.errors.username} />
                        )}
                    </MDBox>

                    <MDBox mb={2}>
                      <MDTypography variant="h6">Role</MDTypography>
                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Choose one..."
                        name="roleId"
                        options={rolesOptions}
                        value={roleSelected}
                        onChange={(selectedOption) => {
                          handleRoleSelected(selectedOption);
                          formikForUpdate.setFieldValue(
                            "roleId",
                            selectedOption,
                          );
                        }}
                      />
                      {formikForUpdate.errors.roleId && (
                        <TextError msg={formikForUpdate.errors.roleId} />
                      )}
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorForUpdate}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {/* Please check the details. Server error! */}
                          {updateErrorMsg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForUpdate}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          User updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={!formikForUpdate.isValid}
                      >
                        Update User Details
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openDeleteUserDetailsModal}
              onClose={handleCloseDeleteUserDetailsModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>
                  Are you sure you want to delete this user?
                </MDTypography>
                <MDBox mt={2} display="flex">
                  <div>
                    <MDButton
                      style={{ width: "100%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseDeleteUserDetailsModal}
                    >
                      Cancel
                    </MDButton>
                  </div>
                  <div style={{ float: "right" }}>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="error"
                      onClick={deleteUserDetailsData}
                    >
                      Delete
                    </MDButton>
                  </div>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessDeleteUser}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessDeleteUser(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Deleted successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorDeleteUser}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorDeleteUser(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {deleteErrorMsg}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getRoleByClientReducer: state.getRoleByClientReducer,
    userDetailsReducer: state.getUsersDetailsReducer,
    getAllRolesReducer: state.getAllRolesReducer,
    getAllClientsReducer: state.getAllClientsReducer,

    userRolesByDepartmentData: state.getUserRolesByDepartment,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getUsersDetails: (jwtToken) => dispatch(getUsersDetails(jwtToken)),
    createUserDetails: (payload, jwtToken) =>
      dispatch(createUserDetails(payload, jwtToken)),
    updateUserDetails: (payload, jwtToken) =>
      dispatch(updateUserDetails(payload, jwtToken)),
    deleteUserDetails: (email, jwtToken) =>
      dispatch(deleteUserDetails(email, jwtToken)),
    getAllRoles: (jwtToken) => dispatch(getAllRoles(jwtToken)),

    getAllClients: (jwtToken) => dispatch(getAllClients(jwtToken)),
    getUserRolesByDepartment: (departmentId, jwtToken) =>
      dispatch(getUserRolesByDepartment(departmentId, jwtToken)),

    getRoleByClient: (clientId, jwtToken) =>
      dispatch(getRoleByClient(clientId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);
